
import React from 'react'
import Grid from '@material-ui/core/Grid';
import HandIcon from '../assets/imgs/HandIcon.svg'
import Button from '@material-ui/core/Button';


function Banner() {
  return (
    <div className="ExpansionBannerContainer">

      <div className="ExpansionContainer ExpansionHeaderInner">
        <div className="BannerSmallText">URGENT APPEAL</div>
        <h1 className="ExpansionSectionTitle">Build The Largest Islamic Center in NYC. Donate A Brick Package.</h1>

        <div className="ExpansionBannerGrid">
        <Grid container spacing={3}>

          <Grid item md={12} xs={12}>
            <div className="BannerVidoeContainer"><iframe src="https://www.youtube.com/embed/q5RGTX5FOK8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
          </Grid>

          {/* <Grid item md={4} xs={12}>
            <div className="BannerwgtContainer">
                <div className="BannerwgtTopSection"><img className="handIcon" src={HandIcon} /></div>
                <div className="BannerwgtBodySection">
                  <h1>Support us with your generous donations</h1>
                  <Button className="ExpansionFillButton" variant="contained" href="#contained-buttons"> Donate now</Button>
                </div>
            </div>
          </Grid> */}

        </Grid>
        </div>

      </div>
    </div>
  );
}










export default Banner